import { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useSelectedWorkflowStep } from '../../hooks/useSelectedWorkflowStep';
import { SupportEventOrchestrator } from './templates/SupportEventOrchestrator/SupportEventOrchestrator';
import { SupportTaskOrchestrator } from './templates/SupportTaskOrchestrator/SupportTaskOrchestrator';

export const ModalOrchestratorSupportTool = () => {
  const { step } = useSelectedWorkflowStep();
  const [show, setShow] = useState(false);
  const [mode, setMode] = useState<'event' | 'task'>('task');

  useEffect(() => {
    if (show) setMode('task');
  }, [show]);

  if (!step) return null;

  return (
    <>
      <Button
        size="sm"
        variant="secondary"
        onClick={() => setShow(true)}
        data-testid="open-support-modal"
      >
        Soporte
      </Button>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        backdrop="static"
        keyboard={false}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Soporte para orquestador en paso <strong>{step.name}</strong>
          </Modal.Title>
        </Modal.Header>
        <div className="m-2 d-flex gap-2">
          <Button
            size="sm"
            variant={mode === 'event' ? 'primary' : 'outline-primary'}
            onClick={() => setMode('event')}
            data-testid="support-mode-event-btn"
          >
            evento
          </Button>
          <Button
            size="sm"
            variant={mode === 'task' ? 'primary' : 'outline-primary'}
            onClick={() => setMode('task')}
            data-testid="support-mode-task-btn"
          >
            tarea
          </Button>
        </div>
        {mode === 'event' ? <SupportEventOrchestrator /> : <SupportTaskOrchestrator />}
      </Modal>
    </>
  );
};
